import React from 'react'
import styles from '../normal/modalButton.module.css'
function ModalButton({color, fontSize, children, onClick}) {
  return (
    <button className={styles.modalButton} style={{background: color, fontSize: fontSize}} onClick={onClick}>{children}</button>
  )
}

export default ModalButton